var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSesame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "sesame",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sesamzaad") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sesamzaad",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(32.000000, 20.000000)",
    fill: "#1A1919"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.71860608,16.3731169 C5.3129449,15.6577997 7.2859858,16.0469393 7.84704892,16.8980182 C8.40811203,17.7488784 7.36178835,18.7575808 5.75005221,19.4549714 C3.88046316,20.2634198 -0.366654164,20.0961772 0.0254065526,19.4512549 C0.579324348,18.5391816 2.10655928,17.0969603 3.71860608,16.3731169",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7987498,14.9164506 C21.5634441,15.4484729 22.5443179,16.3857956 21.6826802,17.2669836 C20.8204149,18.1477527 18.6280396,18.2112184 17.1890481,17.5838929 C15.0700971,16.6599755 13.2489226,14.218538 14.3129479,14.0543232 C15.8184605,13.8218253 18.0146012,14.3781446 19.7987498,14.9164506",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.862467,27.7757996 C15.2573977,26.4062807 16.0948313,25.6037585 16.9997271,26.1990182 C17.9044178,26.7945259 18.3942877,28.7027784 17.6023757,29.5784375 C16.3326919,30.9814258 15.5403699,31.644864 14.3965881,31.9820374 C13.4402242,32.2636763 14.4632301,29.1606896 14.862467,27.7757996",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9106437,34.432944 C25.979627,36.2130253 26.3121685,37.6445766 25.0225498,37.9542885 C23.732931,38.2642777 22.0541623,36.9530621 22.0059793,35.3712298 C21.9340998,32.9980655 22.5186146,29.528848 23.3106059,30.0531678 C24.4306627,30.7945911 25.8406072,32.6229175 25.9106437,34.432944",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7878345,21.2438329 C26.4754474,21.9767884 25.9441894,22.1721587 24.6100417,21.8505854 C23.4174627,21.5634146 24.1648256,19.9117298 25.2173366,19.2131769 C26.7675892,18.1854458 30.0384272,17.63247 29.9996584,18.2750735 C29.9451319,19.1836631 29.0742091,20.5253627 27.7878345,21.2438329",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5882604,29.735893 C31.7703314,28.6149808 31.8591781,26.9259105 32.5235045,26.2699484 C33.1878309,25.6139863 34.1898131,26.2214251 34.9940586,27.3603089 C35.9266595,28.6812189 36.3146169,32.1582032 35.7086864,31.9944053 C34.8516341,31.7625721 33.4148621,30.8686151 32.5882604,29.735893",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50155596,6.79747907 C4.1888968,6.18148879 3.55085042,5.25288056 4.35531123,4.51245948 C5.1595233,3.77184579 6.8940642,3.87605177 7.93682849,4.55522053 C9.47236857,5.5552898 10.5566743,7.9183194 9.69524949,7.98978044 C8.47761322,8.09109716 6.82864268,7.42059618 5.50155596,6.79747907",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72864784,29.5865497 C6.1603083,30.258895 4.59015424,30.1513893 4.11414837,28.9665917 C3.63844491,27.7820423 4.70477065,25.9825006 6.28792867,26.0001285 C8.8240057,26.0276877 10.229342,26.1997466 11.7411294,26.9016374 C13.004934,27.488574 9.3139228,28.9065076 7.72864784,29.5865497",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8016423,5.11039312 C19.2802412,6.75794102 19.1003971,8.18911405 17.8838762,7.97953486 C16.6676004,7.76995568 15.6436647,5.93511847 16.1187571,4.47594719 C16.8312733,2.28637478 18.4692273,-0.65126755 18.9825428,0.128334394 C19.7095151,1.23059586 20.3321091,3.43457513 19.8016423,5.11039312",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8738149,6.10903441 C27.6718735,4.45530146 28.0284924,3.95085608 29.1881228,4.00369689 C30.2243401,4.05131505 30.1731587,6.99934058 29.5690942,8.50499639 C28.6796107,10.7215454 26.2744971,12.7712772 26.0953621,11.7132322 C25.8417252,10.2167928 26.0916474,7.72928104 26.8738149,6.10903441",
    id: "Fill-10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text1",
    xmlSpace: "preserve",
    x: 5,
    y: 102,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fontWeight: 500,
    fill: "#000000"
  }, "sesamzaad"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSesame);
export default __webpack_public_path__ + "static/media/sesame.88c7451ea11a5961575e170b433ac692.svg";
export { ForwardRef as ReactComponent };